import React from "react";
import SectionHeader from "@/components/SectionHeader";
import WorkCard from "@/components/WorkCard";

const MOMENTS = [
  {
    index: "01",
    tag: "Bollywood · Dhurandhar",
    title: "The Hamza Way of investing.",
    caption: "Patience, strategy, and the long game: investment lessons hidden in a blockbuster.",
    image: "01 Moment Marketing - Connecting Dhurandhar to Finance.jpg",
    link: "https://www.instagram.com/p/DWVtEE-EnYA/",
  },
  {
    index: "02",
    tag: "Halloween",
    title: "The scariest financial story?",
    caption: "Watching your money disappear due to poor planning.",
    image: "02 Moment Marketing - Connecting Halloweeen to Finance.jpg",
    link: "https://www.instagram.com/p/DQeYIYfCfnQ/",
  },
  {
    index: "03",
    tag: "Valentine's Day",
    title: "Things you can say to your partner, but not your portfolio.",
    caption: "Healthy relationships (financial and romantic) require honesty and alignment.",
    image: "03 Moment Marketing - Connecting Valentine's Day To Finance.jpg",
    link: "https://www.instagram.com/p/DUucWSFEi_8/",
  },
  {
    index: "04",
    tag: "ICC Champions Trophy",
    title: "Gold: India's go-to investment.",
    caption: "A nation's pride translated into a timeless wealth-building asset.",
    image: "04 Moment Marketing - India winning the cricket world cup.jpg",
    link: "https://www.instagram.com/p/DHA15TchB4k/",
  },
  {
    index: "05",
    tag: "Neeraj Chopra · Olympic Gold",
    title: "Don't put all your eggs in one basket, unless you're Neeraj Chopra.",
    caption: "A medal-worthy portfolio diversification lesson wrapped in national pride.",
    image: "05 Moment marketing - NEERAJ CHOPRA winning gold.jpg",
    link: "https://www.instagram.com/p/CwfVGs0ye2j/",
  },
  {
    index: "06",
    tag: "Viral · UPI Down",
    title: "How to go from dish tasting to dish washing?",
    caption: "When India's payment system crashed: a humorous take on contingency planning.",
    image: "06 Moment Marketing - When UPI was down.jpg",
    link: "https://www.instagram.com/p/DHsU0JETx7V/",
  },
];

const WHY_IT_WORKS = [
  "Posted within hours of the trend peaking, not days later.",
  "Added a genuine separate take, not just a hashtag.",
  "Made audiences laugh first, then think.",
  "Required zero product pushiness.",
];

export default function MomentMarketingPage() {
  return (
    <>
      <SectionHeader
        eyebrow="Case Study 02"
        pageIndex="02"
        title="Moment Marketing, Culture & Memes"
        kicker="Real-time moment marketing that transforms pop culture into financial wisdom."
        lede="People engage much more with content that entertains first and educates second. By connecting blockbuster movies, holidays, sporting victories, and viral memes to investment principles, made finance feel culturally native, not preachy."
      />

      {/* Approach strip */}
      <section className="mx-auto max-w-[1440px] px-6 pt-20 lg:px-12">
        <div className="grid gap-px overflow-hidden border border-[#EDE4D3]/12 bg-[#EDE4D3]/10 md:grid-cols-2 lg:grid-cols-4">
          {[
            ["Monitor", "Track trends as they peak."],
            ["Create", "Ship within hours, not days."],
            ["Shareable", "Made for forwarding, not lecturing."],
            ["Magic", "Audiences don't realise they're learning."],
          ].map(([h, d]) => (
            <div key={h} className="bg-[#0B0E14] p-7">
              <p className="font-serif text-xl text-[#D4A574]">{h}.</p>
              <p className="mt-3 text-sm text-[#EDE4D3]/65">{d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Wins grid */}
      <section className="mx-auto max-w-[1440px] px-6 pt-28 lg:px-12">
        <div className="mb-10 flex items-end justify-between">
          <h2 className="font-serif text-3xl tracking-tight lg:text-4xl">
            Real-time <span className="italic text-[#D4A574]">wins</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
          {MOMENTS.map((m) => (
            <WorkCard key={m.index} {...m} ratio="1/1" />
          ))}
        </div>
      </section>

      {/* Why it works */}
      <section className="mx-auto mt-32 max-w-[1100px] px-6 lg:px-12">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4A574]">Why It Works</p>
        <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight lg:text-4xl">
          We join the chatter with a <span className="italic text-[#D4A574]">funny, emotional,</span> or <span className="italic">inspirational</span> take.
        </h2>
        <ul className="mt-10 grid gap-px overflow-hidden border border-[#EDE4D3]/12 bg-[#EDE4D3]/10 md:grid-cols-2">
          {WHY_IT_WORKS.map((t, i) => (
            <li key={i} className="flex items-start gap-4 bg-[#0B0E14] p-7">
              <span className="font-serif text-2xl italic text-[#D4A574]">0{i + 1}</span>
              <p className="text-[15px] leading-relaxed text-[#EDE4D3]/80">{t}</p>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
